// extracted by mini-css-extract-plugin
export default {"wrapper":"EditCompanyRequest_wrapper__0eBM+","actions":"EditCompanyRequest_actions__n7Mxj","actionButtons":"EditCompanyRequest_actionButtons__x+mXf"};